module.exports = __webpack_public_path__ + "assets/lock.e2f6c892.svg";